import { useCallback, useEffect, useRef } from "react";

/**
 * @param {Function} callback - 실행할 콜백 함수
 * @param {number} delay - 대기 시간 (ms)
 * @returns {Function} - 디바운스가 적용된 함수
 */

const useDebounceCallback = <T extends (...args: Parameters<T>) => void>(
  callback: T,
  delay: number,
): ((...args: Parameters<T>) => void) => {
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    return () => {
      if (timer.current) {
        clearTimeout(timer.current);
      }
    };
  }, []);

  const debouncedFunction = useCallback(
    (...args: Parameters<T>) => {
      if (timer.current) {
        clearTimeout(timer.current);
      }

      timer.current = setTimeout(() => {
        callback(...args);
      }, delay);
    },
    [callback, delay],
  );

  return debouncedFunction;
};

export default useDebounceCallback;
